import { c as _c } from "react/compiler-runtime";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { FaroTextButton } from "@components/common/faro-text-button";
import { BulkRemoveFromProjectsDialog } from "@components/table/member-group-projects/bulk-actions/bulk-remove-from-projects-dialog";
import { Text, DeleteIcon } from "@flat-ui";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { useState } from "react";
/** Bulk action button that opens a dialog to remove a member/team from selected projects */
export function BulkRemoveFromProjects(t0) {
  const $ = _c(22);
  const {
    member,
    projects,
    onSuccessfulComplete
  } = t0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const mode = useBulkActionsMode();
  let t1;
  if ($[0] !== mode) {
    t1 = getBulkActionButtonConfig(mode, "Remove member");
    $[0] = mode;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const bulkActionConfig = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsDialogOpen(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== bulkActionConfig.sx) {
    t3 = {
      ...bulkActionConfig.sx
    };
    $[3] = bulkActionConfig.sx;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DeleteIcon sx={{
      width: "18px",
      height: "18px"
    }} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== bulkActionConfig.shouldShowText) {
    t5 = bulkActionConfig.shouldShowText && <Text variant="buttonM">Remove member</Text>;
    $[6] = bulkActionConfig.shouldShowText;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== bulkActionConfig.rippleColor || $[9] !== bulkActionConfig.tooltipText || $[10] !== t3 || $[11] !== t5) {
    t6 = <FaroTextButton onClick={t2} tooltipText={bulkActionConfig.tooltipText} sx={t3} startIcon={t4} rippleColor={bulkActionConfig.rippleColor}>{t5}</FaroTextButton>;
    $[8] = bulkActionConfig.rippleColor;
    $[9] = bulkActionConfig.tooltipText;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsDialogOpen(false);
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isDialogOpen || $[15] !== member || $[16] !== onSuccessfulComplete || $[17] !== projects) {
    t8 = <BulkRemoveFromProjectsDialog isOpen={isDialogOpen} onClose={t7} member={member} projects={projects} onSuccessfulComplete={onSuccessfulComplete} />;
    $[14] = isDialogOpen;
    $[15] = member;
    $[16] = onSuccessfulComplete;
    $[17] = projects;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}